module.exports = __webpack_public_path__ + "img/发展历程.c36ff765.svg";